var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconGq = function SvgIconGq(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6DA544",
    d: "M7.305 7.826h15.95C21.558 3.256 17.16 0 12 0a11.96 11.96 0 0 0-8.485 3.515z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M7.305 16.174h15.95C21.558 20.744 17.16 24 12 24a11.96 11.96 0 0 1-8.485-3.515z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0052B4",
    d: "M3.515 3.515c-4.687 4.687-4.687 12.285 0 16.971L12 12.001z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DEDDE0",
    d: "M14.087 9.913v2.608c0 1.598 2.087 2.087 2.087 2.087s2.087-.489 2.087-2.087V9.914z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#786145",
    d: "M16.696 12.052h-1.044v1.513h1.044z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6DA544",
    d: "M17.217 11.479a1.044 1.044 0 0 0-2.087 0 .522.522 0 0 0 0 1.043h2.087a.522.522 0 1 0 0-1.043"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgIconGq;